import {Component, inject, signal} from '@angular/core';
import {WjGridFilterModule} from '@mescius/wijmo.angular2.grid.filter';
import {WjFlexGrid, WjGridModule} from '@mescius/wijmo.angular2.grid';
import {ColumnDeclaration, Wijmo, WjGridUtils} from '../../lib/wjgrid-utils';
import {WjGridColumnChooser} from '../../lib/wjgrid-columchooser';
import {CollectionView, DataType} from '@mescius/wijmo';
import {WjGridSearchModule} from '@mescius/wijmo.angular2.grid.search';
import {FxRate, FxRateApi} from '../../../api-client-kt/src';
import {PortfolioSegmentDataContext} from '../../data/portfolio-segment-data-context.service';
import {findIsoCurrencyDescriptionByCode} from '../../data/iso-currencies';

const xratesColumns: ColumnDeclaration[] = [
    {header:"From Currency Code", binding:"fromCurrency",dataType:DataType.String, visible: true},
    {header:"From Currency Name", binding:"fromCurrencyName",dataType:DataType.String, visible: true, width: 200},
    {header:"From Symbol", binding:"fromSymbol",dataType:DataType.String, visible: true, width: 40, align: 'center'},
    {header:"To Currency Code", binding:"toCurrency",dataType:DataType.String, visible: true},
    {header:"To Currency Name", binding:"toCurrencyName",dataType:DataType.String, visible: true, width: 100},
    {header:"To Symbol", binding:"toSymbol",dataType:DataType.String, visible: true, width: 40, align: 'center'},
    {header:"Rate", binding:"rate",dataType:DataType.Number, format: 'N4', visible: true},
    {header:"Valid From", binding:"validFrom",dataType:DataType.String, visible: true, align: 'right'},
];


@Component({
    selector: 'app-portfolio-config-fxrates',
    imports: [
        WjGridFilterModule,
        WjGridModule,
        WjGridSearchModule
    ],
    templateUrl: './portfolio-config-fxrates.component.html',
    styleUrl: './portfolio-config-fxrates.component.scss'
})
export class PortfolioConfigFxratesComponent {

    protected visibleRowCount = signal(0);

    protected readonly Wijmo = Wijmo;

    private readonly pfsegData = inject(PortfolioSegmentDataContext);
    private readonly fxRateApi = inject(FxRateApi);

    async onFxGridInitialized(fxGrid: WjFlexGrid) {
        WjGridUtils.addColumns(fxGrid, xratesColumns, true);
        WjGridColumnChooser.addColumnChooser('portfolio.fxrates', fxGrid);
        fxGrid.itemsSource = await this.loadFxRates();
        fxGrid.autoSizeRows(0, 0, true, 10);
        fxGrid.refreshed.addHandler(() => this.visibleRowCount.set(fxGrid.rows.length));
    }

    async loadFxRates(): Promise<CollectionView> {
        const currencies = await this.fxRateApi.getFxRates({ id: this.pfsegData.portfolioId()!, key: 'tiering' });
        const cv = new CollectionView(currencies);

        cv.calculatedFields = {
            fromCurrencyName: ($: FxRate) => findIsoCurrencyDescriptionByCode($.fromCurrency)?.name,
            toCurrencyName: ($: FxRate) => findIsoCurrencyDescriptionByCode($.toCurrency)?.name,
            fromSymbol: ($: FxRate) => findIsoCurrencyDescriptionByCode($.fromCurrency)?.symbol,
            toSymbol: ($: FxRate) => findIsoCurrencyDescriptionByCode($.toCurrency)?.symbol,
        };
        return cv;
    }
}
